import { NotificationGroup } from '@progress/kendo-react-notification';
import { Notification } from 'context';
import React, { useCallback, useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';

const ANCHOR_ELEMENT = '.layout_container';

interface Props {
  notifications: Notification[];
}

export default function ContentCenteredNotifications({ notifications }: Props) {
  const [position, setPosition] = useState({ left: 0, width: 0 });

  const updatePosition = useCallback(() => {
    const siteContentElement = document.querySelector(ANCHOR_ELEMENT);
    if (siteContentElement) {
      const rect = siteContentElement.getBoundingClientRect();
      setPosition({
        left: rect.left + rect.width / 2,
        width: rect.width,
      });
    }
  }, []);

  const debouncedUpdatePosition = useCallback(debounce(updatePosition, 100), [
    updatePosition,
  ]);

  useLayoutEffect(() => {
    updatePosition();

    window.addEventListener('resize', debouncedUpdatePosition);
    return () => {
      window.removeEventListener('resize', debouncedUpdatePosition);
      debouncedUpdatePosition.cancel();
    };
  }, [debouncedUpdatePosition]);

  if (!notifications.length) {
    return null;
  }

  return (
    <NotificationGroup
      className="alert"
      style={{
        position: 'fixed',
        top: '20px',
        left: `${position.left}px`,
        maxWidth: `${position.width}px`,
        transform: 'translateX(-50%)',
      }}
    >
      {notifications?.map(({ notification }) => notification)}
    </NotificationGroup>
  );
}
